import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const FieldingPositionPage = () => {
  useEffect(() => {
    document.title = 'The Pitcher | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        await loadScript('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div id="outer_m">
      {/* Header */}
      <header>
        <div id="zero">
          <img className="logo" src="/logo.png" alt="SportsTMS Logo" />
        </div>
        <div id="one">
          <div id="two">Sports Tournament Management System</div>
          <div id="three">THE OFFICIAL SITE OF INDIAN BASEBALL</div>
        </div>
        <img className="" src="/second_logo.png" alt="Secondary Logo" />
      </header>

      {/* Navigation */}
      <nav>
        <ul className="slimmenu">
          <li>
            <Link to="/">
              <span className="glyphicon glyphicon-home" style={{fontSize: '15px'}}></span>
            </Link>
          </li>
          <li>
            <a href="#">About</a>
            <ul>
              <li><a href="/history">History</a></li>
              <li><a href="/pdf/Amateur_Baseball_federation.zip">Constitution</a></li>
              <li><a href="/international-recognition">International Recognition</a></li>
              <li><a href="/registration">Registration</a></li>
              <li><Link to="/affiliates">Affiliates</Link></li>
              <li><Link to="/bearer">Executive Committee</Link></li>
            </ul>
          </li>
          <li>
            <a href="#">Rules</a>
            <ul>
              <li>
                <a href="#">Basics</a>
                <ul>
                  <li><Link to="/score-keeping">Keeping Score</Link></li>
                  <li><Link to="/baseball-lingo">Baseball Lingo</Link></li>
                  <li><Link to="/abbreviation">Abbreviation</Link></li>
                  <li><Link to="/stats">Stats 101</Link></li>
                </ul>
              </li>
              <li><Link to="/rules">Baseball Rules</Link></li>
              <li>
                <a href="#">Play Baseball</a>
                <ul>
                  <li><Link to="/skills">4 Skills of Baseball</Link></li>
                  <li><Link to="/batting-order">Batting Order</Link></li>
                  <li><Link to="/fielding-position">Fielding Position</Link></li>
                  <li><Link to="/why-play">Why Play Baseball</Link></li>
                  <li><a href="/pdf/manual.pdf" target="_blank">Manual</a></li>
                </ul>
              </li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manual</a></li>
            </ul>
          </li>
          <li><a href="/events">Events</a></li>
          <li>
            <a href="#">Schedule</a>
            <ul>
              <li><a href="/forthcoming-events">Forthcoming Events</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Participants</a>
            <ul>
              <li><a href="/admin-login">User Login</a></li>
              <li><a href="#">Roster</a></li>
              <li><a href="/certificate-verify">Certificates</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Information</a>
            <ul>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/website-info">Website information</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Downloads</a>
            <ul>
              <li><a href="/pdf/Roster_form.pdf" target="_blank">Roster form</a></li>
              <li><a href="/pdf/team_Roster.pdf" target="_blank">Team roster</a></li>
              <li><a href="/pdf/Score_Sheet.pdf" target="_blank">Score sheet</a></li>
            </ul>
          </li>
          <li><a href="/photo-gallery">Gallery</a></li>
          <li><a href="/contact">Contact Us</a></li>
        </ul>
      </nav>

      {/* Main Content */}
      <div id="main">
        <div className="container" style={{marginTop: '50px'}}>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="heading3">Fielding Positions Of Baseball</h3>
                </div>
                <div className="panel-body">
                  <div className="panel-group" id="accordion">
                    
                    {/* Pitcher */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                            <b>1. Pitcher</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapseOne" className="panel-collapse collapse in">
                        <div className="panel-body">
                          <p className="depart_p">
                            As a pitcher, you must be able to throw the ball fast and accurately. You are the most important player on the team. Here are some tips on how to pitch.<br /><br />
                            &nbsp;&nbsp;&nbsp;* Grip the ball on the wide seams.<br />
                            &nbsp;&nbsp;&nbsp;* Step toward the batter and push off the mound.<br />
                            &nbsp;&nbsp;&nbsp;* Throw overhead with a downward snap of the wrist.<br />
                            &nbsp;&nbsp;&nbsp;* Follow through with the fingers almost touching the ground.<br />
                            &nbsp;&nbsp;&nbsp;* Keep your eyes on the catcher's glove at all times.<br />
                            &nbsp;&nbsp;&nbsp;* After the pitch be ready to field the ball.<br />
                            &nbsp;&nbsp;&nbsp;* Warm up about 15 minutes before pitching a game or before an important practice session.<br />
                            &nbsp;&nbsp;&nbsp;* For practice in control, try the "simulated strike zone" idea. Drive two poles into the ground, or use two standards about 8 feet apart. Tie heavy cord to the posts to form a strike zone-a rectangle as wide as home plate and as high as the distance between the batter's knees and armpits. Use a catcher and a home plate, and practice pitching into this zone.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Catcher */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                            <b>2. CATCHER</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapseTwo" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            A catcher should be a good leader and have a strong arm.<br /><br />
                            &nbsp;&nbsp;&nbsp;* Always wear proper equipment while catching.<br />
                            &nbsp;&nbsp;&nbsp;* Take a position directly behind home plate, near enough to touch the batter with your glove.<br />
                            &nbsp;&nbsp;&nbsp;* Crouch down, with feet apart for comfort.<br />
                            &nbsp;&nbsp;&nbsp;* Hold your glove facing the pitcher, and keep your bare hand behind the glove.<br />
                            &nbsp;&nbsp;&nbsp;* Don't turn your head when balls are thrown in the dirt or fouled off.<br />
                            &nbsp;&nbsp;&nbsp;* Always throw overhand.<br />
                            &nbsp;&nbsp;&nbsp;* Encourage your pitcher and team members.<br />
                            &nbsp;&nbsp;&nbsp;* Catch all fly balls between home and first base, fair or fouled.<br />
                            &nbsp;&nbsp;&nbsp;* Try to block all balls thrown in the dirt.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* First Baseman */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                            <b>3. FIRST BASEMAN</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapseThree" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            You must be the best in catching all types of throws. Height is an advantage.<br /><br />
                            &nbsp;&nbsp;&nbsp;* The foot opposite your glove hand should touch the base as you stretch to catch a ball.<br />
                            &nbsp;&nbsp;&nbsp;* Always stretch to catch the ball.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Second Baseman */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapse4">
                            <b>4. SECOND BASEMAN</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapse4" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            &nbsp;&nbsp;&nbsp;* Be ready to cover second base on steals.<br />
                            &nbsp;&nbsp;&nbsp;* Cover first base when the ball is bunted by the batter.<br />
                            &nbsp;&nbsp;&nbsp;* Back up or cover first base when balls are hit to the first baseman.<br />
                            &nbsp;&nbsp;&nbsp;* Catch all fly balls behind the first baseman.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Third Baseman */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapse5">
                            <b>5. THIRD BASEMAN</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapse5" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            &nbsp;&nbsp;&nbsp;* Try to develop a good arm and a fast response.<br />
                            &nbsp;&nbsp;&nbsp;* Block all hard-hit balls. Take your time and make good overhand throws.<br />
                            &nbsp;&nbsp;&nbsp;* You must be alert for a bunt or slow-hit ball. Charge it, Grab it, and then throw. Do not throw while moving.<br />
                            &nbsp;&nbsp;&nbsp;* Catch all fly balls between home and third base, fair or foul.<br />
                            &nbsp;&nbsp;&nbsp;* Be sure third base is covered when the ball is hit elsewhere.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Shortstop */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapse6">
                            <b>6. SHORTSTOP</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapse6" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            &nbsp;&nbsp;&nbsp;* Be the leader of the infield and help wherever you can.<br />
                            &nbsp;&nbsp;&nbsp;* Call out who is to catch fly balls.<br />
                            &nbsp;&nbsp;&nbsp;* Cover second base when the ball is hit to first baseman. Second baseman, or right fielder, and when someone tries to steal a base.<br />
                            &nbsp;&nbsp;&nbsp;* You should back up or cover third base when balls are hit to the third baseman.<br />
                            &nbsp;&nbsp;&nbsp;* Catch fly balls behind third baseman.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Center Fielder */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapse7">
                            <b>7. CENTER FIELDER</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapse7" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            &nbsp;&nbsp;&nbsp;* You must be fast and a sure fielder of fly balls.<br />
                            &nbsp;&nbsp;&nbsp;* Be the leader of the outfield. Keep others on their toes and help them on their plays.<br />
                            &nbsp;&nbsp;&nbsp;* Try to catch all balls hit in your direction.<br />
                            &nbsp;&nbsp;&nbsp;* Charge ( run in quickly ) to field ground balls.<br />
                            &nbsp;&nbsp;&nbsp;* Throw the ball as soon as you can, never hold onto it.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Outfielders */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapse8">
                            <b>8 & 9. OUTFIELDERS-RIGHT AND LEFT</b>
                          </a>
                        </h4>
                      </div>
                      <div id="collapse8" className="panel-collapse collapse">
                        <div className="panel-body">
                          <p className="depart_p">
                            For these positions you should be a good hitter and an adequate fielder with a good arm.<br /><br />
                            &nbsp;&nbsp;&nbsp;* Try to catch every ball in the air. (Anybody can catch a ball on a bounce.)<br />
                            &nbsp;&nbsp;&nbsp;* Charge all ground balls.<br />
                            &nbsp;&nbsp;&nbsp;* Get rid of the ball as soon as you can.<br />
                            &nbsp;&nbsp;&nbsp;* Back up all bases in case of wild throws.
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div id="outer_main">
          <div id="outer1">
            <div id="aku11">
              <h4 className="link_heading">LOCATION</h4>
              <h4 className="ft">B4/317B, Keshav Puram,<br />Delhi - 110035</h4>
            </div>
            <div id="aku22">
              <h4 className="link_heading">AROUND THE WEB</h4>
              <div id="social">
                <div id="contact_a_dn">
                  <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl4"><i className="fa fa-twitter" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                </div>
              </div>
            </div>
            <div id="aku33">
              <h4 className="link_heading">CONTACT US</h4>
              <label className="ft">Phone : +918890029024, +919165276531<br />Email: abfi.secretarygeneral@gmail.com</label>
            </div>
          </div>
        </div>
        <div id="main_link">
          <div id="main_link_inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/rules">Rules</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/schedule">Schedule</a></li>
              <li><a href="/affiliates">Affiliates</a></li>
              <li><a href="/photo-gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="/international-recognition">International & Recognition</a></li>
              <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
              <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
              <li><a href="/registration">Certificate of Registration</a></li>
              <li><a href="/international-participation">International Participation</a></li>
              <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
              <li><a href="/affiliates">Affiliated Units</a></li>
              <li><a href="#">Firm Name</a></li>
              <li><a href="#">Media Coverage</a></li>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
              <li><a href="/history">History</a></li>
              <li><a href="/bearer">Executive Committee</a></li>
              <li><a href="/website-info">Website Info</a></li>
            </ul>
            <div className="text-center">
              <hr />
              <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FieldingPositionPage;